import { Controller } from "@hotwired/stimulus"

// STD-6 — the federal state belongs to a country, and offering all fifty at
// once invites the Bavarian branch in Switzerland. The select holds the
// subdivisions of the chosen country; picking another country rewrites it.
//
// The list is rewritten rather than hidden option by option, because the field
// has to stay an ordinary simple_form input: a hand-built select inside
// `f.input … do` silently loses simple_form's error component, and a missing
// federal state then reports "there were errors" without naming a field.
//
// Convenience only. Site validates the pair, so a browser without this
// controller still cannot save a mismatch — it just keeps the list the server
// rendered.
export default class extends Controller {
  static targets = ["country", "state"]
  static values = { states: Object }

  narrow() {
    const options = this.statesValue[this.countryTarget.value] || []
    const chosen = this.stateTarget.value

    this.stateTarget.replaceChildren(this.blank())
    for (const [label, code] of options) {
      const option = new Option(label, code, false, code === chosen)
      this.stateTarget.add(option)
    }
  }

  // The empty entry simple_form renders as `include_blank`, so a country change
  // leaves the field unanswered rather than silently picking the first state.
  blank() {
    return new Option(" ", "")
  }
}
